import {
	Button,
	DatePicker,
	Empty,
	Popconfirm,
	Select,
	Space,
	Spin,
	Table,
	Typography,
	Upload,
	UploadProps,
} from "antd";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { getMenuDatas } from "./slice";
import { AppDispatch, RootState } from "../../../../app/store";
import { useDispatch, useSelector } from "react-redux";
import menusAdmin from "../../../../apis/admin/menuService";
import notificationHandler from "../../../atoms/Notification";
import {
	CloudUploadOutlined,
	DeleteOutlined,
	FormOutlined,
	LoadingOutlined,
	PlusCircleOutlined,
} from "@ant-design/icons";
import kitchenAdmin from "../../../../apis/admin/kitchenService";
import "moment/locale/vi";
import locale from "antd/es/date-picker/locale/vi_VN";
import "./menu.scss";
import moment from "moment";
import { ColumnsType } from "antd/lib/table";
import printJS from "print-js";

interface DataType {
	index: string;
	foodList: string;
	applicableDate: string;
	action: string;
}

const ListMenu = () => {
	const { menus }: any = useSelector((state: RootState) => state.menulist);
	const dispatch = useDispatch<AppDispatch>();
	const dateFormat = "DD-MM-YYYY";
	const { RangePicker } = DatePicker;
	const [KitchenId, setKitchenId] = React.useState<any>("");
	const [dataKitchen, setDataKitchen] = React.useState<any>();
	const [dateString, setDateString] = React.useState<any>([]);
	const [loading, setLoading] = React.useState(false);
	const [currentPage, setCurrentPage] = React.useState(1);

	const handlePageChange = (page: any) => {
		setCurrentPage(page);
	};

	const [pageSize, setPageSize] = React.useState(10);

	const displayedIndex = (index: any) =>
		(currentPage - 1) * pageSize + index + 1;

	const antIcon = (
		<LoadingOutlined style={{ fontSize: 70, position: "fixed" }} spin />
	);

	const { Title } = Typography;

	const props: UploadProps = {
		customRequest: (componentsData: any) =>
			KitchenId && importMenus(componentsData),
		beforeUpload: (file) => {
			if (!KitchenId) {
				notificationHandler("error", "Vui lòng chọn bếp ăn!");
				return;
			}
			const isExcel = [
				".csv",
				"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				"application/vnd.ms-excel",
			].includes(file.type);
			if (!isExcel) {
				notificationHandler("error", "File không hợp lệ, vui lòng thử lại");
				return;
			}
			return isExcel || Upload.LIST_IGNORE;
		},
		onChange: (info) => {},
		progress: {
			strokeColor: {
				"0%": "#108ee9",
				"100%": "#87d068",
			},
			strokeWidth: 3,
			format: (percent) => percent && `${parseFloat(percent.toFixed(2))}%`,
		},
		showUploadList: false,
	};

	useEffect(() => {
		setLoading(true);
		dispatch(
			getMenuDatas({
				fromDate: "",
				toDate: "",
				kitchenId: KitchenId,
				isSpecial: "0",
			})
		)
			.then(() => {})
			.catch((err: any) => {
				notificationHandler("error", err.response.data.data.msg_content);
			})
			.finally(() => setLoading(false));
	}, []);

	useEffect(() => {
		kitchenAdmin
			.getKitchenData(1, "")
			.then((data: any) => {
				setDataKitchen(data.data.data.payload);
			})
			.catch((err: any) => {
				notificationHandler("error", err.response.data.data.msg_content);
			});
	}, [dispatch]);

	const confirm = (id: number) => {
		setLoading(true);
		menusAdmin
			.removeMenu(id)
			.then(() => {
				dispatch(
					getMenuDatas({
						fromDate: dateString[0] || "",
						toDate: dateString[1] || "",
						kitchenId: KitchenId,
						isSpecial: "0",
					})
				);
				notificationHandler("success", "Xóa thực đơn thành công");
				setLoading(false);
			})
			.catch((err) => {
				notificationHandler("error", err.response.data.data.msg_content);
				setLoading(false);
			});
	};

	const onchangeDate = (date: any, dateString: any) => {
		setDateString(dateString);
		dispatch(
			getMenuDatas({
				fromDate: dateString[0],
				toDate: dateString[1],
				kitchenId: KitchenId || "",
				isSpecial: "0",
			})
		)
			.unwrap()
			.then((item) => {
				setCurrentPage(1);
			});
	};

	const handleMenu = (value: any) => {
		if (value == undefined) value = "";
		setKitchenId(value);
		dispatch(
			getMenuDatas({
				fromDate: dateString[0] || "",
				toDate: dateString[1] || "",
				kitchenId: value,
				isSpecial: "0",
			})
		)
			.unwrap()
			.then((item) => {
				setCurrentPage(1);
			});
	};

	const importMenus = (fileData: any) => {
		let formData = new FormData();
		formData.append("file", fileData.file);
		menusAdmin
			.importMenus(KitchenId, formData)
			.then((res: any) => {
				if (res?.data?.success) {
					notificationHandler("success", res?.data?.data?.payload);
					dispatch(
						getMenuDatas({
							fromDate: dateString[0] || "",
							toDate: dateString[1] || "",
							kitchenId: KitchenId,
							isSpecial: "0",
						})
					);
				}
			})
			.catch((err: any) => {
				notificationHandler("error", err.response.data.data.msg_content);
				return;
			})
			.finally(() => {
				setLoading(false);
			});
	};

	const wrapText = (
		ctx: CanvasRenderingContext2D,
		text: string,
		x: number,
		y: number,
		maxWidth: number,
		lineHeight: number
	) => {
		let line = "";
		let testLine = "";
		for (let i = 0; i < text.length; i++) {
			testLine = line + text[i];
			if (ctx.measureText(testLine).width > maxWidth && line !== "") {
				ctx.fillText(line, x, y);
				y += lineHeight;
				line = text[i];
			} else {
				line = testLine;
			}
		}
		if (line) {
			ctx.fillText(line, x, y);
		}
	};

	const createQRCodeCanvas = async (data: any): Promise<HTMLCanvasElement> => {
		const canvas = document.createElement("canvas");
		const width = 800;
		const height = 300;
		canvas.width = width;
		canvas.height = height;
		const ctx = canvas.getContext("2d");
		if (!ctx) throw new Error("Canvas context not available");
		ctx.fillStyle = "#ffffff";
		ctx.fillRect(0, 0, width, height);

		// Title
		ctx.font = "bold 28px Arial";
		ctx.fillStyle = "#000";
		ctx.fillText("MẪU THỰC PHẨM", 32, 50);

		const rectX = 360;
		const rectY = 20;
		const rectWidth = 400;
		const rectHeight = 56;
		const borderRadius = 16;

		ctx.strokeStyle = "#ccc";
		ctx.lineWidth = 2;

		ctx.beginPath();
		ctx.moveTo(rectX + borderRadius, rectY);
		ctx.lineTo(rectX + rectWidth - borderRadius, rectY);
		ctx.quadraticCurveTo(
			rectX + rectWidth,
			rectY,
			rectX + rectWidth,
			rectY + borderRadius
		);
		ctx.lineTo(rectX + rectWidth, rectY + rectHeight - borderRadius);
		ctx.quadraticCurveTo(
			rectX + rectWidth,
			rectY + rectHeight,
			rectX + rectWidth - borderRadius,
			rectY + rectHeight
		);
		ctx.lineTo(rectX + borderRadius, rectY + rectHeight);
		ctx.quadraticCurveTo(
			rectX,
			rectY + rectHeight,
			rectX,
			rectY + rectHeight - borderRadius
		);
		ctx.lineTo(rectX, rectY + borderRadius);
		ctx.quadraticCurveTo(rectX, rectY, rectX + borderRadius, rectY);
		ctx.closePath();
		ctx.stroke();
		ctx.font = "20px Arial";
		ctx.fillStyle = "#444";
		ctx.fillText("Món:", 380, 55);
		ctx.font = "bold 20px Arial";
		ctx.fillStyle = "#000";
		wrapText(ctx, data.dish, 432, 55, 240, 40);

		// Date & Time
		ctx.font = "18px Arial";
		ctx.fillStyle = "#222";
		ctx.fillText("Ngày:", 32, 110);
		ctx.fillText(data.date, 100, 110);
		ctx.fillText("Giờ:", 220, 110);
		ctx.fillText(data.time || "......", 270, 110);

		// Chef
		ctx.fillText("Bếp ăn:", 360, 110);
		ctx.font = "18px Arial";
		ctx.fillStyle = "#222";
		ctx.fillText(data.chef, 440, 110);

		// Meal
		ctx.font = "18px Arial";
		ctx.fillStyle = "#222";
		ctx.fillText("Bữa ăn:", 32, 170);
		ctx.font = "bold 18px Arial";
		ctx.fillText(data.meal, 120, 170);

		// Note
		ctx.font = "18px Arial";
		ctx.fillStyle = "#222";
		ctx.fillText("Ghi chú:", 360, 170);
		ctx.font = "18px Arial";
		ctx.fillStyle = "#222";
		ctx.fillText(
			"................................................................",
			440,
			170
		);

		return canvas;
	};

	const handlePrint = async (record: any) => {
		const foodList = record.foodList
			? record.foodList.toString().split(",")
			: [];
		if (foodList.length === 0) {
			notificationHandler("error", "Không có thực đơn để in");
			return;
		}
		const mealType =
			record.menuType === 1
				? "Bữa sáng"
				: record.menuType === 0
				? "Bữa trưa"
				: "Bữa trưa đặc biệt";
		const kitchenName =
			dataKitchen.find((kitchen: any) => kitchen.id === record.kitchenId?.[0])
				?.kitchenName ??
			"................................................................";

		await Promise.all(
			foodList.map(async (food: string) => {
				const data = {
					dish: food,
					date: moment(record.applicableDate).format("DD-MM-YYYY"),
					time: record.time || "......",
					chef: kitchenName,
					meal: mealType,
				};
				const canvas = await createQRCodeCanvas(data);
				const dataUrl = canvas.toDataURL("image/png");
				return dataUrl;
			})
		).then(async (data) => {
			printJS({
				printable: data,
				type: "image",
			});
		});
	};

	const columns: ColumnsType<DataType> = [
		{
			title: "STT",
			dataIndex: "index",
			key: "index",
			width: "5%",
			align: "center",
			render: (_: any, __: any, index: any) => displayedIndex(index),
		},
		{
			title: "Món ăn",
			dataIndex: "foodList",
			key: "foodList",
			width: "10%",
			align: "left",
			render: (text: any, object: any, index: number) => {
				const dataMenu = text.toString().split(",");
				return (
					<div key={index} className="flex flex-col">
						{dataMenu?.map((item: any, key: number) => (
							<span className="truncates mx-auto" title={item} key={key}>
								Món {key + 1}: {item}
							</span>
						))}
					</div>
				);
			},
		},
		{
			title: "Ngày áp dụng",
			dataIndex: "applicableDate",
			key: "applicableDate",
			align: "center",
			width: "38%",
			render: (text: any, object: any, index: number) => {
				const applicableDate = moment(text).format("DD-MM-YYYY");
				return <div>{applicableDate}</div>;
			},
		},
		{
			title: "Hành Động",
			dataIndex: "action",
			align: "center",
			width: "8%",
			render: (text: string, record: any) => {
				return (
					<Space size="small">
						<Button
							onClick={() => {
								handlePrint(record);
							}}
							className="mr-1 bg-cyan-500 hover:text-cyan-500 hover:bg-white hover:border-cyan-500 border-cyan-500 active:bg-cyan-500 focus:bg-cyan-500 focus:text-white text-white"
						>
							<FormOutlined className="mr-1" />
							In
						</Button>
						<Button className="mr-1 hover:border-[#FAAD14] hover:text-[#FAAD14] bg-[#FAAD14] border-[#FAAD14] p-[5px_10px] text-white ">
							<Link
								to={`/admin/editMenu/${record.id}`}
								className="flex items-center"
							>
								<FormOutlined className="mr-1" />
								Sửa
							</Link>
						</Button>
						<Popconfirm
							title="Bạn có muốn xóa thực đơn?"
							onConfirm={() => confirm(record.id)}
							okText="Có"
							cancelText="Không"
							okType="danger"
						>
							<Button
								danger
								className="bg-[#ff4d4f] text-white "
								loading={loading}
							>
								<div className="flex items-center">
									<DeleteOutlined className="pr-1" />
									Xóa
								</div>
							</Button>
						</Popconfirm>
					</Space>
				);
			},
		},
	];
	return (
		<div id="menu">
			<Spin indicator={antIcon} spinning={loading} />
			<div className="flex justify-between">
				<div className="w-[80%]">
					<div className="flex header-select">
						<RangePicker
							onChange={onchangeDate}
							placeholder={["Chọn ngày bắt đầu ", "Chọn ngày kết thúc"]}
							format={dateFormat}
							className="w-[80%] max-w-[350px]"
							locale={locale}
						/>
						<Select
							className="w-[40%] max-w-[250px] ml-4 select-kitchen"
							placeholder="Chọn bếp ăn"
							onChange={handleMenu}
							allowClear
							showSearch
							optionFilterProp="children"
							filterOption={(input: string, option: any) =>
								(option?.label ?? "").toLowerCase().includes(input.trim())
							}
							options={dataKitchen?.map((item: any, key: number) => ({
								value: item.id,
								label: item.kitchenName,
							}))}
						>
							{/* <Select.Option value={""}>Chọn bếp ăn</Select.Option>
              {dataKitchen?.map((item: any, key: number) => (
                <Select.Option key={key} value={item.id} label={item.kitchenName}>
                  <span className="truncate">{item.kitchenName}</span>
                </Select.Option>
              ))} */}
						</Select>
					</div>
				</div>
				<Upload {...props} className="mr-3">
					<Button
						icon={<CloudUploadOutlined />}
						className="bg-cyan-500 hover:text-cyan-500 hover:bg-white hover:border-cyan-500 border-cyan-500 active:bg-cyan-500 focus:bg-cyan-500 focus:text-white text-white"
					>
						Import thực đơn
					</Button>
				</Upload>
				<Button className="p-[5px_15px] border-green-600 hover:border-green-600 hover:text-green-600 hover:bg-white bg-green-600 text rounded-sm text-white">
					<Link
						to={"/admin/createMenu"}
						className="flex items-center hover:text-white"
					>
						<PlusCircleOutlined className="mr-1" />
						Thêm mới
					</Link>
				</Button>
			</div>
			<Title className="mt-[30px]" level={3}>
				Danh sách thực đơn
			</Title>
			<Table
				className="mt-[15px]"
				dataSource={menus}
				columns={columns}
				pagination={{
					locale: { items_per_page: "bản ghi / Trang" },
					current: currentPage,
					defaultPageSize: 10,
					onShowSizeChange(current, size) {
						setPageSize(size);
					},
					onChange: handlePageChange,
					showSizeChanger: true,
					pageSizeOptions: ["10", "20", "50"],
					showTotal: (total: any, range: any) =>
						`${range[0]}-${range[1]} Tổng ${total} bản ghi`,
				}}
				rowKey={(record: any) => record.id}
				locale={{
					emptyText: (
						<Empty
							image={Empty.PRESENTED_IMAGE_DEFAULT}
							description="Không có dữ liệu!"
						/>
					),
				}}
			/>
		</div>
	);
};

export default ListMenu;
